<div class="grid-container">
  <h2 class="title">{{tcoTitle}}</h2>

  <div>
    <canvas *ngIf="chartId" [id]="chartId"></canvas>
  </div>

  <div class="box-container">
    <table class="table" *ngIf="this.tco">
      <tr class="first-table-item">
        <th>Campo</th>
        <th>Precio</th>
      </tr>
      <tr *ngFor="let item of this.tco | keyvalue: originalOrder">
        <td>{{item.key}}</td>
        <td>{{item.value}}</td>
      </tr>
      <tr class="last-table-item">
        <td>Total</td>
        <td>{{tco?.getTCO()}}</td>
      </tr>
    </table>
  </div>
</div>
